import * as ScholarshipsApplyNowUploads from "$lib/data/generated/uploads/scholarships/ApplyNow/uploads.js";
import * as ScholarshipsFeatures01Uploads from "$lib/data/generated/uploads/scholarships/Features 01/uploads.js";
import * as ScholarshipsFeatures02Uploads from "$lib/data/generated/uploads/scholarships/Features 02/uploads.js";
import * as ScholarshipsFeatures03Uploads from "$lib/data/generated/uploads/scholarships/Features 03/uploads.js";
import * as ScholarshipsFeatures03HOLDUploads from "$lib/data/generated/uploads/scholarships/Features 03 - HOLD/uploads.js";
import * as ScholarshipsFeatures04Uploads from "$lib/data/generated/uploads/scholarships/Features 04/uploads.js";
import * as ScholarshipsFormApplyNowUploads from "$lib/data/generated/uploads/scholarships/Form Apply Now/uploads.js";
import * as ScholarshipsFormSubmission01Uploads from "$lib/data/generated/uploads/scholarships/FormSubmission 01/uploads.js";
import * as ScholarshipsFormSubmission02Uploads from "$lib/data/generated/uploads/scholarships/FormSubmission 02/uploads.js";
import * as ScholarshipsFormSubmission03Uploads from "$lib/data/generated/uploads/scholarships/FormSubmission 03/uploads.js";
import * as ScholarshipsPageBannerUploads from "$lib/data/generated/uploads/scholarships/PageBanner/uploads.js";
import * as ScholarshipsSideBySide01Uploads from "$lib/data/generated/uploads/scholarships/SideBySide 01/uploads.js";
import * as ScholarshipsSideBySide02Uploads from "$lib/data/generated/uploads/scholarships/SideBySide 02/uploads.js";
import * as ScholarshipsSideBySide03Uploads from "$lib/data/generated/uploads/scholarships/SideBySide 03/uploads.js";
import * as ScholarshipsSideBySide04Uploads from "$lib/data/generated/uploads/scholarships/SideBySide 04/uploads.js";

export const uploads = {
  ...ScholarshipsApplyNowUploads.uploads,
  ...ScholarshipsFeatures01Uploads.uploads,
  ...ScholarshipsFeatures02Uploads.uploads,
  ...ScholarshipsFeatures03Uploads.uploads,
  ...ScholarshipsFeatures03HOLDUploads.uploads,
  ...ScholarshipsFeatures04Uploads.uploads,
  ...ScholarshipsFormApplyNowUploads.uploads,
  ...ScholarshipsFormSubmission01Uploads.uploads,
  ...ScholarshipsFormSubmission02Uploads.uploads,
  ...ScholarshipsFormSubmission03Uploads.uploads,
  ...ScholarshipsPageBannerUploads.uploads,
  ...ScholarshipsSideBySide01Uploads.uploads,
  ...ScholarshipsSideBySide02Uploads.uploads,
  ...ScholarshipsSideBySide03Uploads.uploads,
  ...ScholarshipsSideBySide04Uploads.uploads
};
